import { render } from "./ListeBureauPage.vue?vue&type=template&id=44db5ea1&ts=true"
import script from "./ListeBureauPage.vue?vue&type=script&lang=ts"
export * from "./ListeBureauPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__